/* tslint:disable */
/* eslint-disable */
/**
 * Notification service API
 * Service for handling and managing notifications
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationEventDto
 */
export interface NotificationEventDto {
    /**
     * Notification event id. Every notification has different texts for different languages and channels
     * @type {string}
     * @memberof NotificationEventDto
     */
    notificationEventId?: string;
    /**
     * Notification channel - way to get to user
     * @type {string}
     * @memberof NotificationEventDto
     */
    channel?: string;
    /**
     * Text id for notification message
     * @type {string}
     * @memberof NotificationEventDto
     */
    symbolicTextId?: string;
}

/**
 * Check if a given object implements the NotificationEventDto interface.
 */
export function instanceOfNotificationEventDto(value: object): boolean {
    return true;
}

export function NotificationEventDtoFromJSON(json: any): NotificationEventDto {
    return NotificationEventDtoFromJSONTyped(json, false);
}

export function NotificationEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'notificationEventId': json['notificationEventId'] == null ? undefined : json['notificationEventId'],
        'channel': json['channel'] == null ? undefined : json['channel'],
        'symbolicTextId': json['symbolicTextId'] == null ? undefined : json['symbolicTextId'],
    };
}

export function NotificationEventDtoToJSON(value?: NotificationEventDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'notificationEventId': value['notificationEventId'],
        'channel': value['channel'],
        'symbolicTextId': value['symbolicTextId'],
    };
}

